import * as Sentry from '@sentry/vue';
import { defineStore } from 'pinia';
import { computed, ref, watch } from 'vue';

import { useAuthStore } from '@/stores/auth';
import { useConfigCatStore } from '@/stores/configCat';

export type UserTenant = {
    tenantId: string;
    roleNames?: string[];
    tenantName: string;
};

export const useTenantStore = defineStore('tenant', () => {
    const tenantId = ref<string>();
    const tenantName = ref<string>();
    const tenantRoles = ref<string[]>();
    const tenantElqano = ref<boolean>(false);

    const configCatStore = useConfigCatStore();
    const authStore = useAuthStore();

    const tenantDataLoadedPromise = new Promise<void>((resolve) => {
        watch(
            () => tenantId.value,
            (tenantIdValue) => {
                if (tenantIdValue) resolve();
            },
            { immediate: true }
        );
    });

    const tenantAdmin = computed(() => {
        if (authStore.isDescopeEnabled) {
            return tenantRoles.value
                ? tenantRoles.value.includes('Tenant Admin')
                : false;
        }
        return configCatStore.isAdmin;
    });

    function updateTenant(tenant: any) {
        if (tenantId.value != tenant.tenantId) {
            authStore.updateCredentials(tenant.tenantId);
        }

        const roles = tenant.roleNames ?? [];
        tenantElqano.value = tenant.tenantName === 'Elqano';

        tenantId.value = tenant.tenantId;
        tenantName.value = tenant.tenantName;
        tenantRoles.value = roles;
        Sentry.setTag('tenant', tenant.tenantName);
    }

    return {
        tenantId,
        tenantName,
        tenantRoles,
        tenantAdmin,
        tenantElqano,
        updateTenant,
        tenantDataLoadedPromise
    };
});
